import Script from 'next/script';
import { StandaloneVideoPlaylist } from 'base/components/VideoPlaylist';
import { VideoPlaylist } from 'base/components/VideoPlaylist/VideoPlaylist';

export const MotherhoodStandaloneVideoPlaylist: typeof StandaloneVideoPlaylist = ({ title, playlistId }) => {
  if (!playlistId) {
    return null;
  }

  return (
    <>
      <VideoPlaylist
        data-variant="carousel"
        data-playlist-id={playlistId}
        data-title={title}
        data-site="motherhood.se"
        data-hide-video-titles
      />
      <Script id="aller-video-loader-cdn" type="module" src="https://cdn.video.aller.com/reels/beta/script.js" />
    </>
  );
};
